import { Await, useLoaderData } from 'react-router-typesafe'
import { argomentoProblemaLoader } from '@/routes/admin/tickets/pages/ArgomentoProblema.route'
import React from 'react'
import { GlobalLoadingComponent } from '@/components/GlobalLoadingComponent/GlobalLoadingComponent'
import { Lookup } from 'devextreme-react'
import '@/routes/admin/tickets/pages/ArgomentoProblema.scss'
import { ValueChangedEvent } from 'devextreme/ui/lookup'
import { LookupRef } from 'devextreme-react/cjs/lookup'
import { ArgomentoProblemaGrid } from './ArgomentoProblema.grid'
import { piattaforma_ticket, qs_supporto_applicazione } from '@/model/qsadminapi/QsAdminApiModuleModel'

export const ArgomentoProblema = () => {
  const { apps, platforms } = useLoaderData<typeof argomentoProblemaLoader>()
  const [selectedApp, setSelectedApp] = React.useState<qs_supporto_applicazione>()
  const [selectedPlatform, setSelectedPlatform] = React.useState<piattaforma_ticket>()
  const qsSuppAppsRef = React.useRef<LookupRef>(null)
  const ticketPlatformRef = React.useRef<LookupRef>(null)

  return (
    <>
      <div className={'content-block'}>
        <h2>Argomento Problema</h2>
        <div className="content-block dx-card responsive-paddings filter-header">
          <React.Suspense fallback={<GlobalLoadingComponent />}>
            <Await resolve={apps} errorElement={<div>Could not load QS Support Apps</div>}>
              {(qs_supp_apps) => (
                <Lookup
                  ref={qsSuppAppsRef}
                  className={'filter-field'}
                  dataSource={qs_supp_apps.data.value}
                  searchEnabled={true}
                  value={selectedApp}
                  placeholder="Applicazione Supporto QS"
                  displayExpr="nome"
                  showClearButton={true}
                  dropDownCentered={true}
                  dropDownOptions={{ showTitle: true, title: 'Applicazione Supporto QS', hideOnOutsideClick: true }}
                  onValueChanged={(e: ValueChangedEvent) => {
                    if (e.value) {
                      setSelectedApp(e.value)
                      setSelectedPlatform(undefined)
                    } else {
                      setSelectedApp(undefined)
                    }
                  }}
                />
              )}
            </Await>
            <Await resolve={platforms} errorElement={<div>Could not load Ticket Platforms</div>}>
              {(ticketPlatforms) => (
                <Lookup
                  ref={ticketPlatformRef}
                  className={'filter-field'}
                  dataSource={ticketPlatforms.data.value}
                  searchEnabled={true}
                  value={selectedPlatform}
                  placeholder="Piattaforma Ticket"
                  displayExpr="nome"
                  showClearButton={true}
                  dropDownCentered={true}
                  dropDownOptions={{ showTitle: true, title: 'Piattaforme Ticket', hideOnOutsideClick: true }}
                  onValueChanged={(e: ValueChangedEvent) => {
                    if (e.value) {
                      setSelectedPlatform(e.value)
                      setSelectedApp(undefined)
                    } else {
                      setSelectedPlatform(undefined)
                    }
                  }}
                />
              )}
            </Await>
          </React.Suspense>
        </div>
        <div className="content-block dx-card wide-card">
          <ArgomentoProblemaGrid
            selectedApp={selectedApp ? selectedApp.id : undefined}
            selectedPlatform={selectedPlatform ? selectedPlatform.id : undefined}
          />
        </div>
      </div>
    </>
  )
}
